<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-06-25 17:58:52
 * @LastEditTime : 2025-04-30 11:02:58
 * @LastEditors  : yangxr
 * @Description  : 自检报告库
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\reporSelfCheck.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">自检报告编号</span>
                  <el-input v-model="tableParam.checkoutNumber" clearable style="width: 120px"></el-input>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">原物料</span>
                  <el-select v-model="tableParam.rawName" placeholder="请选择" style="width: 120px" filterable>
                    <el-option v-for="(item, index) in rawDicArry" :key="index" :label="item.itemName" :value="item.itemName"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">报告日期</span>
                  <el-date-picker v-model="tableParam.reportDate" style="width: 140px" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">报告天数</span>
                  <el-input v-model="tableParam.checkStartDay" style="width: 100px" clearable placeholder="请输入" />至<el-input v-model="tableParam.checkEndDay" style="width: 100px" clearable placeholder="请输入" />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">试验日期</span>
                  <el-date-picker v-model="tableParam.samplingDate" style="width: 140px" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">厂家</span>
                  <el-input v-model="tableParam.manufacturer" clearable style="width: 120px"></el-input>
                </span>
                <el-button style="margin-left: 12px" icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div>
                <el-button size="small" class="bottom_all" style="margin-left: 0" @click="reportDig = true">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
                <el-button size="small" class="bottom_all" style="margin-left: 10px" @click="set28Day"> 28天 </el-button>
              </div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"> </el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">
                        <span v-if="scope.row.expireStatus == 0">过期</span>
                        <span v-else-if="scope.row.expireStatus == 1">不过期</span>
                        <span v-else>/</span>
                      </span>
                      <span v-else-if="item.label == '报告天数'">
                        <span v-if="scope.row.reportDay == 0">/</span>
                        <span v-else-if="scope.row.reportDay == 1">3d</span>
                        <span v-else-if="scope.row.reportDay == 2">28d</span>
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button class="bottom_one" size="mini" @click="modifyLookFun(scope.row, false)">修改</el-button>
                        <el-button class="bottom_one" size="mini" style="margin-left: 10px" @click="download(scope.row)">导出</el-button>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 产品名+配合比-自检报告-修改 -->
    <el-dialog :visible.sync="look11ModifyType" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">修改</span>
      <div class="dialogOtherinfo">
        <el-form label-width="110px" :disabled="modifyType" label="110px" :inline="true">
          <el-form-item label="自检报告编号" prop="startTime">
            <el-input v-model="data11Info.checkoutNumber" :disabled="modifyType" tplaceholder="请输入" clearable style="width: 215px; margin-left: 25px"></el-input>
          </el-form-item>
          <el-form-item label="原物料名称">
            <span style="width: 215px; margin-left: 25px">{{ data11Info.rawName }}</span>
          </el-form-item>
          <el-form-item label="供应商" prop="startTime">
            <el-input v-model="data11Info.supplierName" :disabled="modifyType" style="width: 215px; margin-left: 25px" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="试验日期" prop="startTime">
            <el-date-picker v-model="data11Info.samplingDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="检测人" prop="startTime" class="FZYplaceholder">
            <el-select ref="inspectorId" v-model="data11Info.inspectorId0" multiple placeholder="请选择" value-key="id" style="width: 215px; margin-left: 25px" filterable @change="selectInspector">
              <el-option v-for="item in userList" :key="item.id" :label="item.name + '_' + item.company" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地">
            <el-input v-model="data11Info.originPlace" tplaceholder="请输入" clearable style="width: 215px; margin-left: 25px"></el-input>
          </el-form-item>
          <el-form-item label="生产厂家">
            <el-input v-model="data11Info.manufacturer" tplaceholder="请输入" clearable style="width: 215px; margin-left: 25px"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">水泥出厂日期</span>
            <el-date-picker v-model="data11Info.dataOfProduction" type="date" value-format="yyyy-MM-dd" style="width: 215px; margin-left: 25px" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item>
            <span slot="label">水泥出厂编号</span>
            <el-input v-model="data11Info.factoryNumber" style="width: 215px; margin-left: 25px" clearable placeholder="请输入" />
          </el-form-item>
        </el-form>
        <br />
        <el-table ref="singleTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="table11Modify" tooltip-effect="dark" highlight-current-row>
          <el-table-column prop="acceptanceItems" label="验收项目" width="auto" align="center"></el-table-column>
          <!-- <el-table-column prop="technicalRequirements" label="技术要求" width="260" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.resultValueType == 3">
                {{scope.row.technicalRequirements+'：'+(scope.row.section?scope.row.section:'')}}
              </div>
              <div v-else>
                {{scope.row.section?scope.row.section:''}}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="lowerLimitVlue" label="下限值" width="auto" align="center"></el-table-column>
          <el-table-column prop="upperLimitVlue" label="上限值" width="auto" align="center"></el-table-column>
          <el-table-column label="结果值" width="auto" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.resultValueType == 3">
                <el-input v-model="scope.row.resultValue" :disabled="modifyType" style="width: 100%" @input="checkOkNgFun(scope.row.resultValue, scope.row.technicalRequirements, scope.row.section, scope.row)"></el-input>
              </div>
              <div v-else>
                {{ scope.row.resultValue }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="resultJudge" label="结果判断" width="auto" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.resultJudge == 'OK'" style="color: #4d906f">OK</span>
              <span v-if="scope.row.resultJudge == 'NG'" style="color: red">NG</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look11ModifyType = false">取 消</el-button>
        <el-button v-if="!modifyType" class="bottom_all" style="margin-left: 24px" @click="selfdetectionupdateManyFun()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog v-dialogDrag :visible.sync="look4Type" width="600px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">导出</span>
      <div class="dialogOtherinfo">
        <el-form ref="look4form" :model="look4form" label-width="110px" :hide-required-asterisk="true">
          <el-form-item prop="signerId0" :rules="[{ required: true, message: '请选择签发人', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">签发人</span>
            <el-select v-model="look4form.signerId0" placeholder="请选择" style="width: 380px" filterable>
              <el-option v-for="(item, index) in userList" :key="index" :label="item.name + '_' + item.company" :value="[item.id]" @click.native="setSignature(item)"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="checkOneId0" :rules="[{ required: true, message: '请选择校核人', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">校核人</span>
            <el-select v-model="look4form.checkOneId0" placeholder="请选择" style="width: 380px" filterable>
              <el-option v-for="(item, index) in userList" :key="index" :label="item.name + '_' + item.company" :value="[item.id]" @click.native="setCheckOneSignature(item)"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="checkOneId0">
            <span slot="label">出厂日期</span>
            <el-date-picker v-model="look4form.dataOfProduction" type="date" value-format="yyyy-MM-dd" style="width: 380px" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item prop="checkOneId0">
            <span slot="label">出厂编号</span>
            <el-input v-model="look4form.factoryNumber" style="width: 380px" clearable placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look4Type = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="confirmDownLoad()">确 定</el-button>
      </span>
    </el-dialog>
    <customizedReport :visible.sync="reportDig" @confirm="gettableData()"></customizedReport>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { selfdetectionqueryByReportId, selfdetectionupdateMany } from "@/api/smart/produceCoordinate.js";
import { queryPage, rawQueryPage, exportReport, save28dSelfReport } from "@/api/smart/reporSelfCheck.js";
import { getDicType } from "@/api/common.js";
import { permissionsCompanyList } from "@/api/common.js";
import { getUserInfoList } from "@/api/basedata/user.js";
export default {
  mixins: [mixin],
  components: { customizedReport: () => import("./components_data/customizedReport.vue") },
  data() {
    return {
      table: [
        { label: "自检报告编号", prop: "checkoutNumber", status: true, width: "auto" },
        { label: "试验日期", prop: "samplingDate", status: true, width: "220" },
        { label: "报告日期", prop: "reportDate", status: true, width: "auto" },
        { label: "报告天数", prop: "reportDay", status: true, width: "200" },
        { label: "原物料名称", prop: "rawName", status: true, width: "150" },
        { label: "品牌", prop: "brand", status: true, width: "auto" },
        { label: "规格", prop: "specification", status: true, width: "auto" },
        { label: "产地", prop: "originPlace", status: true, width: "auto" },
        { label: "厂家", prop: "manufacturer", status: true, width: "auto" },
        { label: "水泥出厂日期", prop: "dataOfProduction", status: true, width: "auto" },
        { label: "水泥出厂编号", prop: "factoryNumber", status: true, width: "auto" },
        { label: "状态", prop: "expireStatus", status: true, width: "auto" },
        { label: "操作", prop: "", status: true, width: "180" },
      ],
      queryPage: queryPage,
      tableData: [],
      pagesType: 0,
      specificationArry: [],
      rawArry: [], //原物料管理数据
      rawDicArry: [], //字典数据
      brandArry: [],

      /*添加*/
      companylist: [],
      fromDate: {
        type: 1,
      },
      listFilesa: [],
      reportDig: false,
      look11ModifyType: false,
      data11Info: { sizeValue: "", inspectorId: "" }, //修改的信息
      modifyType: false,
      table11Modify: [], //修改原物料list
      inspectorName: "",
      userList: [],
      selectDataList: [],
      look4Type: false,
      look4form: {
        stationId0: [],
        signerId0: [],
        checkOneId0: [],
        signerSignature: "",
        checkOneSignature: "",
      },
      low: {},
    };
  },
  watch: {},
  async created() {
    this.companylist = await permissionsCompanyList();
    this.tableParam = { ...this.tableParam, reportDate: "", code: "", rawName: "", checkStartDay: "", checkEndDay: "",samplingDate:"",manufacturer:"" };
    this.gettableData();
    getDicType({ code: "MATspec" }).then(res => {
      this.specificationArry = res.data.items; //
    });
    getDicType({ code: "MATname" }).then(res => {
      this.rawDicArry = res.data.items;
    });
    getDicType({ code: "MATbrand" }).then(res => {
      this.brandArry = res.data.items;
    });
    rawQueryPage({ page: 1, pageSize: 99999, enable: 1, isHandOver: 1 }).then(res => {
      this.rawArry = res.data.data;
    });
    //检测人
    getUserInfoList().then(res => {
      this.userList = res.data;
    });
  },
  methods: {
    setSignature(item) {
      this.look4form.signerSignature = item.signatureImg;
    },
    setCheckOneSignature(item) {
      this.look4form.checkOneSignature = item.signatureImg;
    },
    set28Day() {
      save28dSelfReport(this.selectDataList).then(res => {
        if (res.code == 1001) {
          this.$message.success("设置成功!");
          this.gettableData();
        }
      });
    },
    handleSelectionChange(val) {
      this.selectDataList = [];
      this.selectDataList = JSON.parse(JSON.stringify(val));
    },
    download(row) {
      this.low = JSON.parse(JSON.stringify(row));
      this.look4Type = true;
    },
    confirmDownLoad() {
      let parmas = { ...this.low, ...this.look4form };
      this.$Download(exportReport, parmas, `${parmas.rawName}自检报告`);
    },
    /**修改页面——保存检验结果（三方和出场 */
    selfdetectionupdateManyFun() {
      let type = true;
      this.table11Modify.forEach(v => {
        if (v.resultJudge == "NG") {
          type = false;
        }
      });
      if (type) {
        this.nameNameFun();
      } else {
        this.$confirm("是否保存", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "bottom_all_two",
          confirmButtonClass: "bottom_all",
          type: "warning",
        }).then(() => {
          this.nameNameFun();
        });
      }
      this.inspectorIdList = [];
      this.inspectorList = [];
    },
    /**修改页面——保存检验结果（三方和出场 */
    nameNameFun() {
      console.log(this.nameName);
      const params = {
        selfResport: {
          id: this.data11Info.id,
          supplierName: this.data11Info.supplierName,
          inspector: this.data11Info.inspector,
          inspectorId: this.data11Info.inspectorId,
          samplingDate: this.data11Info.samplingDate,
          checkoutNumber: this.data11Info.checkoutNumber,
          sizeId: this.data11Info.sizeValue === "100mm*100mm*100mm" ? 1 : 2,
          sizeValue: this.data11Info.sizeValue,
          originPlace: this.data11Info.originPlace,
          manufacturer: this.data11Info.manufacturer,
          dataOfProduction: this.data11Info.dataOfProduction,
          factoryNumber: this.data11Info.factoryNumber,
        },
        list: this.table11Modify,
      };
      selfdetectionupdateMany(params).then(res => {
        if (res.code == 1001) {
          this.look11ModifyType = false;
          this.$message.success("保存成功");
        }
      });
    },
    selectInspector() {
      this.$forceUpdate();
      this.$nextTick(() => {
        const ids = [];
        const names = [];
        console.log(this.data11Info.inspectorId0);
        console.log(this.$refs.inspectorId.selected);
        this.$refs.inspectorId.selected.forEach(item => {
          ids.push(item.value);
          let inspectorNow = this.userList.find(item2 => item2.id == item.value);
          names.push(inspectorNow.name);
        });
        this.$set(this.data11Info, "inspectorId0", ids);
        this.data11Info.inspectorId = ids.join(",");
        this.data11Info.inspector = names.join(" ");
      });
    },
    /**自检报告库点开修改 */
    modifyLookFun(e, modifyType) {
      this.look11ModifyType = true;
      this.modifyType = modifyType;
      this.data11Info = e;
      this.inspectorName = e.inspector;
      this.table11Modify = [];
      selfdetectionqueryByReportId({ selfReportId: e.id }).then(res => {
        this.table11Modify = res.data.list;
        this.data11Info.sizeValue = res.data.selfResport.sizeValue;
        this.data11Info.samplingDate = res.data.selfResport.samplingDate;
        if (res.data.selfResport.inspectorId) {
          this.data11Info.inspectorId0 = res.data.selfResport.inspectorId.split(",") || [];
          this.data11Info.inspectorId = res.data.selfResport.inspectorId;
          this.data11Info.inspector = res.data.selfResport.inspector;
        } else {
          this.data11Info.inspectorId0 = [];
          this.data11Info.inspectorId = "";
          this.data11Info.inspector = "";
        }
        console.log(this.data11Info.inspectorId0);
      });
    },
    selectRaw(item) {
      this.fromDate.rawName = item.name;
      this.fromDate.rawId = item.rawId;
      this.fromDate.specification = item.specification;
      this.fromDate.specificationId = item.specificationId;
      this.fromDate.brandName = item.brand;
      this.fromDate.brandId = item.brandId;
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.reportDate = "";
      this.tableParam.code = "";
      this.tableParam.rawName = "";
      this.tableParam.checkStartDay = "";
      this.tableParam.checkEndDay = "";
      this.tableParam.samplingDate = "";
      this.tableParam.manufacturer = "";
      this.initData();
    },
    rest() {
      this.listFilesa = [];
    },
    /**验证OK还是NG */
    checkOkNgFun(val, technicalRequirements, section, row) {
      console.log(val, technicalRequirements, section);
      if (technicalRequirements == "≥") {
        if (Number(val) >= Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "＞") {
        if (Number(val) > Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "≤") {
        if (Number(val) <= Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "＜") {
        if (Number(val) < Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "=") {
        if (Number(val) == Number(section)) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "≤x,且x≤") {
        if (Number(val) >= Number(row.section.split(",")[0]) && Number(val) <= Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "<x,且x<") {
        if (Number(val) > Number(row.section.split(",")[0]) && Number(val) < Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "≤x,f且x<") {
        if (Number(val) >= Number(row.section.split(",")[0]) && Number(val) < Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "<x,且x≤") {
        if (Number(val) > Number(row.section.split(",")[0]) && Number(val) <= Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "x≤,或x≥") {
        if (Number(val) <= Number(row.section.split(",")[0]) || Number(val) >= Number(row.section.split(",")[1])) {
          console.log("OK");
          row.resultJudge = "OK";
          return "OK";
        } else {
          console.log("NG");
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "x<或x>") {
        if (Number(val) < Number(row.section.split(",")[0]) || Number(val) > Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "≤x,或x<") {
        if (Number(val) >= Number(row.section.split(",")[0]) || Number(val) < Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      } else if (technicalRequirements == "<x,或x≤") {
        if (Number(val) > Number(row.section.split(",")[0]) || Number(val) <= Number(row.section.split(",")[1])) {
          row.resultJudge = "OK";
          return "OK";
        } else {
          row.resultJudge = "NG";
          return "NG";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  width: 381px;
}
</style>
